import Report from './containers/ReportContainer';

export default Report;
